define([
    "jquery",
    "underscore",
    "marionette",
], function($, _, Marionette){
    return Marionette.Behavior.extend({
        ui: {
            'error_modal': '#error_modal',
            'error_modal_content': '#error_modal_content',
        },

        onOpenErrorModal: function(){
            $(this.ui.error_modal).modal('show');
        },

        onFillErrorModalContent: function($content){
            $(this.ui.error_modal_content).html($content);
        },
    });
});
